import type { RequestStatus as DbRequestStatus } from '@cortex/database';
import {
  Card,
  colors,
  Heading,
  PipelineBar,
  type PipelineSegment,
  Stack,
} from '@cortex/ui';

const PIPELINE_STAGES: {
  stage: DbRequestStatus;
  label: string;
  color: string;
}[] = [
  { stage: 'create', label: 'Create', color: colors.primary15 },
  { stage: 'interview', label: 'Interview', color: colors.primary35 },
  { stage: 'develop', label: 'Develop', color: colors.primary55 },
  { stage: 'review', label: 'Review', color: colors.primary75 },
  { stage: 'finalize', label: 'Finalize', color: colors.primary },
  { stage: 'closed', label: 'Closed', color: colors.surface3 },
];

interface DashboardPipelineProps {
  byStatus: Record<string, number>;
  onStageClick?: (stage: string) => void;
}

export function DashboardPipeline({
  byStatus,
  onStageClick,
}: DashboardPipelineProps) {
  const segments: PipelineSegment[] = PIPELINE_STAGES.map((s) => ({
    stage: s.stage,
    label: s.label,
    count: byStatus[s.stage] ?? 0,
    color: s.color,
  }));

  const total = segments.reduce((sum, s) => sum + s.count, 0);

  return (
    <Card className="p-5">
      <Stack gap="md">
        <Heading level={2} className="text-lg font-semibold">
          Request Pipeline
        </Heading>
        <PipelineBar
          segments={segments}
          total={total}
          onSegmentClick={onStageClick}
        />
      </Stack>
    </Card>
  );
}
